/**
 * Hook to set Sentry feature tags based on current route
 * 
 * This hook should be used in the App component or Layout component
 * to automatically tag errors with the current feature/page
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setSentryTag } from '../config/sentry';

export function useSentryRouteTags(): void {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();

    // Contact Center / Twilio Voice
    if (path.includes('/contact-center') || 
        path.includes('/call-log') ||
        path.includes('/my-calls')) {
      setSentryTag('feature', 'contact-center');
    }
    // Stripe Payments
    else if (path.includes('/payments') || 
             path.includes('/payment')) {
      setSentryTag('feature', 'stripe');
    }
    // Appointments / Calendar
    else if (path.includes('/appointment') || 
             path.includes('/calendar') ||
             path.includes('/unavailability')) {
      setSentryTag('feature', 'appointments');
    }
    // Transactions
    else if (path.includes('/transaction')) {
      setSentryTag('feature', 'transactions');
    }
    // Service Orders / orders dashboard
    else if (path.includes('/orders-dashboard') || path.includes('/service-order')) {
      setSentryTag('feature', 'service-orders');
    }
    // Clients
    else if (path.includes('/client')) {
      setSentryTag('feature', 'clients');
    }
    // Leads
    else if (path.includes('/lead')) {
      setSentryTag('feature', 'leads');
    }
    // WhatsApp
    else if (path.includes('/whatsapp')) {
      setSentryTag('feature', 'whatsapp');
    }
    // Documents
    else if (path.includes('/document')) {
      setSentryTag('feature', 'documents');
    }
    // Authentication
    else if (path.includes('/login') || 
             path.includes('/auth') ||
             path.includes('/profile')) {
      setSentryTag('feature', 'authentication');
    }
    // Tasks
    else if (path.includes('/task')) {
      setSentryTag('feature', 'tasks');
    }
    // Walk-ins
    else if (path.includes('/walk-in')) {
      setSentryTag('feature', 'walk-ins');
    }
    else if (path.includes('/partner-collections')) {
      setSentryTag('feature', 'partner-collections');
    }
    // Collections (Interac portal)
    else if (path.includes('/collections')) {
      setSentryTag('feature', 'collections');
    }
    // Notifications
    else if (path.includes('/notification')) {
      setSentryTag('feature', 'notifications');
    }
    // Reminders
    else if (path.includes('/reminder')) {
      setSentryTag('feature', 'reminders');
    }
    // Settings
    else if (path.includes('/settings')) {
      setSentryTag('feature', 'settings');
    }
    // Dashboard
    else if (path === '/' || path === '/dashboard') {
      setSentryTag('feature', 'dashboard');
    }
    // Default to 'app' if no feature matched
    else {
      setSentryTag('feature', 'app');
    }

    // Set route path tag
    setSentryTag('route.path', path);

  }, [location.pathname]);
}

